export const NavItems = [
    {
        title: "Home",
        link: "/"
    },
    {
        title: "Leaderboard",
        link: "/leaderboard"
    },
    {
        title: "Sports Picks",
        link: "/sports-picks"
    }
]

export const MobileNavItems = [
    {
        title: "Home",
        link: "/"
    },
    {
        title: "Leaderboard",
        link: "/leaderboard"
    },
    {
        title: "Sports Picks",
        link: "/sports-picks"
    },
    {
        title: "Transactions",
        link: "/transactions"
    }
]